function APropos () {
    return (
        <div className="text-white sm:mr-40 sm:ml-40 sm:mt-20 m-8">
            <section className="about-section">
        <h2 className="text-3xl sm:text-4xl poppins-bold">Présentation</h2>
        <p className="mt-8">
          Bienvenue sur Lgrndev, la plateforme dédiée à l'apprentissage et à la diffusion de cours en ligne. 
          Nous offrons un espace où les utilisateurs peuvent créer, partager et consulter divers cours 
          sur des sujets variés. Notre mission est de rendre l'apprentissage accessible à tous.
        </p>
        <p>
          Ce site a été développé par Lucas Langrand, avec pour objectif de faciliter l'accès à des contenus 
          pédagogiques de qualité et de permettre aux créateurs de cours de partager leurs connaissances 
          avec un large public.
        </p>
      </section>
      <section className="legal-notices mt-20">
        <h2 className="text-3xl sm:text-4xl poppins-bold">Mentions Légales</h2>
        <p className="mt-8">
          <strong>Nom du site :</strong> Lgrndev<br />
          <strong>Responsable de la publication :</strong> Lucas Langrand<br />
          <strong>Hébergement :</strong> L’hébergement de ce site est assuré par la société HOSTINGER INTERNATIONAL LTD, dont le siège social se situe 61 Lordou Vironos Street, 6023 Larnaca, Chypre, joignable par le moyen suivant : https://www.hostinger.fr/contact.<br />
          <strong>Propriété intellectuelle :</strong> Tous les contenus présents sur Lgrndev sont protégés par 
          les droits de propriété intellectuelle. Toute reproduction ou représentation, totale ou partielle, 
          de ce site est interdite sans autorisation préalable.<br />
          <strong>Contact :</strong> lucas.langrand@etu.univ-lyon1.fr<br />
          <strong>Conditions d'utilisation :</strong> L'utilisation du site Lgrndev implique l'acceptation des 
          conditions générales d'utilisation. Veuillez les consulter sur notre site.
        </p>
      </section>
        </div>
    )
}

export default APropos;